import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom"

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const CourseSidebar = ({ course }) => {
  const [enrollmentStatus, setEnrollmentStatus] = useState("enrolled");
  const [loadingStatus, setLoadingStatus] = useState(false);

  const handleCompleteCourse = async () => {
    setLoadingStatus(true);
    try {
      const token = localStorage.getItem("access");
      await axios.post(
        `${BASE_URL}/users/my-courses/${course.id}/status/`,
        { status: "completed" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEnrollmentStatus("completed");
    } catch (err) {
      //console.error("Failed to update enrollment status:", err);
    } finally {
      setLoadingStatus(false);
    }
  };

  // Extract materials from description or assume static if not provided
  const materials = course.description
    ? course.description.split("\n").filter((line) => line.trim().startsWith("*"))
    : [];

  return (
    <div className="course-sidebar">
      {/* Course Progress */}
      <div className="sidebar-card mb-4">
        <h5 className="sidebar-title">Course Progress</h5>
        <div className="progress-info mb-3">
          <div className="d-flex justify-content-between">
            <span>
              {course.progress.completed}/{course.progress.total}
            </span>
            <span>{course.progress.percentage}% Complete</span>
          </div>
          <div className="progress mt-2">
            <div className="progress-bar" style={{ width: `${course.progress.percentage}%` }}></div>
          </div>
        </div>

        <Link to={`/course/${course.id}/learn`} className="btn btn-primary w-100 mb-2">Continue Learning</Link>
        {/*<button
          className="btn btn-warning w-100 mb-3"
          onClick={handleCompleteCourse}
          disabled={loadingStatus || enrollmentStatus === "completed"}
        >
          {enrollmentStatus === "completed" ? "Course Completed" : "Complete Course"}
        </button>*/}

        <div className="enrollment-info">
          <i className="fas fa-calendar-check text-success me-2"></i>
          <small className="text-muted">
            You enrolled in this course on <strong>{course.enrolled_on}</strong>
          </small>
        </div>
      </div>

      {/* Course Stats */}
      <div className="sidebar-card mb-4">
        <div className="course-stat">
          <i className="fas fa-signal me-2"></i>
          <span>Level {course.level}</span>
        </div>
        <div className="course-stat">
          <i className="fas fa-users me-2"></i>
          <span>{course.review_count.toLocaleString()} Total Reviews</span> {/* Proxy for enrollment */}
        </div>
        <div className="course-stat">
          <i className="fas fa-clock me-2"></i>
          <span>{new Date(course.created_at).toLocaleDateString()} Last Updated</span>
        </div>
      </div>

      {/* Instructor */}
      <div className="sidebar-card mb-4">
        <h6 className="sidebar-subtitle">A course by</h6>
        <div className="instructor-info">
          <img
            src={course.instructor_image || "/placeholder.svg"}
            alt={course.instructor}
            className="instructor-avatar me-2"
          />
          <span className="instructor-name">{course.instructor}</span>
        </div>
      </div>

      {/* Material Includes */}
      {materials.length > 0 && (
        <div className="sidebar-card">
          <h6 className="sidebar-subtitle">Material Includes</h6>
          <ul className="material-list">
            {materials.map((material, index) => (
              <li key={index} className="material-item">
                <i className="fas fa-check text-success me-2"></i>
                {material.replace(/^\*/, "").trim()}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CourseSidebar;